import React, { FC } from 'react';
import { getFotmattedDateCreated } from 'utils/date';
import { ReactComponent as Fns1 } from 'assets/img/taxStatus/ФНС.svg';
import { ReactComponent as Fns2 } from 'assets/img/taxStatus/fns2.svg';
import { ReactComponent as Fns3 } from 'assets/img/taxStatus/error.svg';
import styles from './EmployedItem.module.scss';
import { InfoEmployeds } from 'components/InfoEmployeds';
import { EmployedType } from 'redux/Api/employedsWorkSupportApi/type';

interface EmployedItemTypes {
  employed: EmployedType;
  role: string;
}

export const EmployedWorkSupportItem: FC<EmployedItemTypes> = ({ employed, role }) => {
  return (
    <div className={styles.root}>
      <p className={styles.test}>{employed.id}</p>
      <div className={styles.nameCell}>
        <InfoEmployeds
          status={employed.app_status}
          avatar={employed.avatar}
          id={employed.id}
          name={employed.name}
          surname={employed.surname}
          patronymic={employed.patronymic}
          phone={employed.phone}
          isDeleted={employed.is_deleted}
        />
      </div>
      <p className={styles.test}>{employed.worker_fns?.inn || '-'}</p>
      <p className={styles.test}>
        {!employed.worker_fns?.fns_status ? (
          '-'
        ) : employed.worker_fns?.fns_status === 2 ? (
          <Fns1 />
        ) : employed.worker_fns?.fns_status === 1 ? (
          <Fns2 />
        ) : (
          <Fns3 />
        )}
      </p>
      <p className={styles.test}>{employed.nationality || '-'}</p>
      <p className={styles.test}>
        {employed.worker_fns?.last_info_update
          ? getFotmattedDateCreated(employed.worker_fns?.last_info_update)
          : '-'}
      </p>
      <div style={{ padding: '0 16px' }} className={styles.test}></div>
    </div>
  );
};
